// extracted by mini-css-extract-plugin
export var closeButton = "_34-0";